<div class="loading-container">
    <div class="spinner"></div>
    <p>Loading...</p>
</div>